import type { ComponentType, SVGProps } from "react";

type IconGlyph = ComponentType<SVGProps<SVGSVGElement>>;

export function Icon({
  glyph: Glyph,
  size = 20,
  ...props
}: SVGProps<SVGSVGElement> & { glyph: IconGlyph; size?: number }) {
  return (
    <Glyph
      aria-hidden="true"
      height={size}
      strokeWidth={1.8}
      width={size}
      {...props}
    />
  );
}
